import { render, staticRenderFns } from "./entrada_internacao.vue?vue&type=template&id=73d44059"
import script from "./entrada_internacao.vue?vue&type=script&lang=js"
export * from "./entrada_internacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports